import Video from './Video.js';
import Events from "@wwdev/bootstrap/Events";

new Video();

Events.on('wwdev.products.reloaded', () => new Video());
Events.on('wwdev.contentable.reloaded', () => new Video());


